export const environment = {
  production: true,
 // API_URL: 'http://localhost:8080/',
 // API_URL: 'http://192.168.1.77:8080/',
 ////FILE_API_URL:'https://wildlifeodisha.in/assets/javaupload/',
 API_URL: 'https://api.wildlifeodisha.in/wildlife/',
 FILE_API_URL:'https://iwlms.s3.ap-south-1.amazonaws.com/',
 GEOSERVER_WMS_URL :'http://mapserver.odishaforestgis.in/geoserver/odisha/wms'

};
